import React, { Component } from 'react'
import i18next from 'i18next'

import { Row, Col } from 'react-bootstrap'

import GridContainer from './GridContainer'
import UnitForm from './UnitForm'

export default class UnitCreate extends Component {
  handleSubmit = createInput => this.props.createUnit(this.props.currentOrganisationId, createInput)

  render() {
    return (
      <GridContainer>
        <div style={{ marginBottom: 365 }}>
          <Row>
            <Col md={12}>
              <header>
                <h1>{i18next.t('unit_create_new')}</h1>
              </header>
            </Col>
          </Row>

          <UnitForm onSubmit={this.handleSubmit} />
        </div>
      </GridContainer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/UnitCreate.js